import React from 'react';
import { RouteComponentProps, Redirect } from '@reach/router';

const RedirectErrorRoute = ({ path }: RouteComponentProps<{}>) => (
  <Redirect from={path} to="/error" noThrow />
);

export default RedirectErrorRoute;
